<template>
    <div :class="['widget-inner margin-top-5 margin-bottom-5', {'flex flex-vertical-middle': entries.length > 1}]">
        <template v-if="content.count">
            <div v-if="entries.length > 1">
                <!--<div v-for="employee of entries" class="col-6 flex-center">-->
                <!--    <person-box-employee :id="employee.employee_id" class="margin-bottom-5"/>-->
                <!--</div>-->

                <div v-for="employee of entries" class="flex flex-align-left full-width full-height">
                    <div class="margin-5 padding-left-5">
                        <person-box-employee :id="employee.employee_id"/>
                    </div>
                </div>

            </div>
            <div v-else class="flex flex-center flex-vertical-middle full-width full-height">
                <person-box-employee :id="entries[0].employee_id"/>
            </div>
        </template>
        <template v-else>
            <div class="widget-empty-message">
                <div :style="isPersonalDashboardWidget ? {color} : {}">
                    {{widget.emptyMessage}}
                </div>
            </div>
        </template>
    </div>
</template>

<script lang="ts">
    import PersonBoxEmployee from '@/components/PersonBoxEmployee.vue';
    import {Component} from 'vue-facing-decorator';
    import {WidgetDefault} from './WidgetDefault.vue';

    interface IWidgetBirthdayEntry
    {
        employee_id: number;
        mdDate: string;
    }

    @Component({
        name: 'WidgetBirthday',
        components: {PersonBoxEmployee},
    })
    export class WidgetBirthday extends WidgetDefault
    {
        get entries(): IWidgetBirthdayEntry[]
        {
            return this.content.entries as IWidgetBirthdayEntry[];
        }
    }

    export default WidgetBirthday;
</script>